/** Minimal shape the summary picker needs from a user record (matches the
 *  generated `AppUser`, whose names are optional/nullable). */
export interface SummaryUser {
  id: number
  first_name?: string | null
  last_name?: string | null
  email: string
}

export interface SummaryPickerItem {
  key: string
  label: string
}

/**
 * Build the homepage "My Summary" user-picker items. "My Summary" (key `self`)
 * is always first and represents the acting user's own view, so that user is
 * never listed again — only OTHER users appear (self is filtered out even if the
 * users endpoint includes them). This is what prevents the old redundant
 * "…(me)" row that just collapsed back to "My Summary".
 */
export function buildSummaryPickerItems(
  users: SummaryUser[] | undefined,
  currentUserId: number | undefined
): SummaryPickerItem[] {
  const others = (users ?? [])
    .filter((u) => u.id !== currentUserId)
    .map((u) => {
      const name = [u.first_name, u.last_name].filter(Boolean).join(' ')
      return {
        key: String(u.id),
        label: name ? `${name} (${u.email})` : u.email,
      }
    })
  return [{ key: 'self', label: 'My Summary' }, ...others]
}
